import React from "react";
import { object } from "prop-types";

import ComponentContainer from "../../layouts/component-container";
import PhotoStoryCard from "../../molecules/PhotoStoryCard";

import "./photoStoryWithSlider.m.css";

const PhotoStoryWithSlider = ({ collection }) => {
  if (!(collection && collection.items && collection.items.length)) return null;

  const { items = [] } = collection;

  if (!items.length) return null;

  return (
    <ComponentContainer collection={collection}>
      <div styleName="wrapper">
        {items.map(({ story }, index) => (
          <PhotoStoryCard
            key={index}
            styleName="story-card"
            story={story}
            headlineSponsor={false}
            imageType={index === 3 ? "image2x1" : "image1x1"}
            aspectRatio={index === 3 ? [2, 1] : [1, 1]}
            widths={index === 0 || index === 3 ? [300, 500, 800] : [200, 250, 400]}
          />
        ))}
      </div>
    </ComponentContainer>
  );
};

PhotoStoryWithSlider.propTypes = {
  collection: object,
};

PhotoStoryWithSlider.storyLimit = 4;

export default PhotoStoryWithSlider;
